import { render, staticRenderFns } from "./x-menu.vue?vue&type=template&id=20ae43dc&scoped=true&"
import script from "./x-menu.vue?vue&type=script&lang=js&"
export * from "./x-menu.vue?vue&type=script&lang=js&"
import style0 from "./x-menu.vue?vue&type=style&index=0&id=20ae43dc&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae43dc",
  null
  
)

export default component.exports